import React from 'react';
import { pain } from '../data/content';
export function PainPoints() {
  return <section className="bg-parchment-deep text-ink" data-id="element-157" data-mp="2ln2iag3shpt6">
      <div className="mx-auto grid max-w-content gap-10 px-5 py-14 sm:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16 lg:py-24" data-id="element-158" data-mp="2lmsrwreu1gmy">
        <h2 className="text-center font-display text-[1.875rem] font-semibold leading-tight tracking-tight text-ink sm:text-4xl lg:self-center lg:text-left lg:text-[2.6rem]" data-id="element-159" data-mp="26wlggvn8sxvr">
          {pain.headline}
        </h2>

        <div data-id="element-160" data-mp="21zcu0iv2a7op">
          <ul className="border-t border-parchment-line" data-id="element-161" data-mp="21zurfitgmry7">
            {pain.situations.map(item => <li key={item.title} className="flex gap-4 border-b border-parchment-line py-4 sm:py-5" data-id="element-162" data-mp="1o0d83iyxo6w8">
                <span aria-hidden="true" className="mt-2.5 h-2 w-2 flex-none rounded-full bg-leaf" data-id="element-163" data-mp="1t0r6e9aqg2h2" />
                <p className="font-sans text-[1.05rem] leading-relaxed text-ink-soft" data-id="element-164" data-mp="3ncxuu9sn0frb">
                  <span className="font-semibold text-ink" data-id="element-165" data-mp="1z056szhbqkwz">{item.title}</span>{' '}
                  {item.description}
                </p>
              </li>)}
          </ul>

          <p className="mt-8 text-center font-display text-2xl font-semibold leading-snug text-gold-deep sm:text-[1.75rem] lg:text-left" data-id="element-166" data-mp="27sqr4k0lsznx">
            {pain.close}
          </p>
        </div>
      </div>
    </section>;
}